module.exports = __webpack_public_path__ + "img/collapse.70f7cd1a.svg";